export default __webpack_public_path__ + "static/media/flagNorway.d0bd59ae.svg";